import { vuetify } from './vuetify';
import i18n from './i18n';
import './validationRules';
import './lodash';
import auth from './auth';
import routeTitle from './routeTitle';
import lodash from './lodash';
import { initializeApi } from './api';

export default { vuetify, i18n, auth, routeTitle, lodash, initializeApi }; // here we don't wanna export a new object, that's why we don't use export default
